import { render, staticRenderFns } from "./modalDiferencasSalariaisBase.vue?vue&type=template&id=61a5ea68&scoped=true&"
import script from "./modalDiferencasSalariaisBase.vue?vue&type=script&lang=js&"
export * from "./modalDiferencasSalariaisBase.vue?vue&type=script&lang=js&"
import style0 from "./modalDiferencasSalariaisBase.vue?vue&type=style&index=0&id=61a5ea68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5ea68",
  null
  
)

export default component.exports